import { Link } from 'react-router-dom';

interface CTABannerProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  primaryLabel?: string;
  primaryTo?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

export default function CTABanner({
  eyebrow = 'Pronto para começar?',
  title,
  subtitle,
  primaryLabel = 'Falar com um especialista',
  primaryTo,
  primaryHref,
  secondaryLabel,
  secondaryHref,
}: CTABannerProps) {
  const primaryContent = (
    <>
      {primaryLabel}
      <i className="ri-arrow-right-line text-sm"></i>
    </>
  );

  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-primary-600 text-[11px] font-semibold tracking-[0.2em] uppercase">
            {eyebrow}
          </span>
          <h2 className="mt-4 text-[28px] md:text-[40px] font-semibold text-foreground-900 leading-[1.1] tracking-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-4 text-[15px] text-foreground-500 leading-relaxed font-light max-w-lg mx-auto">
              {subtitle}
            </p>
          )}

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            {primaryTo ? (
              <Link
                to={primaryTo}
                className="btn-premium inline-flex items-center justify-center gap-2 bg-primary-600 text-white font-medium text-[15px] px-8 py-3.5 rounded-full hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {primaryContent}
              </Link>
            ) : (
              <a
                href={primaryHref}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-premium inline-flex items-center justify-center gap-2 bg-primary-600 text-white font-medium text-[15px] px-8 py-3.5 rounded-full hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {primaryContent}
              </a>
            )}

            {secondaryLabel && secondaryHref && (
              <a
                href={secondaryHref}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 text-foreground-600 text-[15px] font-medium px-6 py-3.5 rounded-full hover:text-primary-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                {secondaryLabel}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}